module.exports = __webpack_public_path__ + "static/img/组 5 拷贝@2x.1e81bdb5.png";